import { computed, ref, toRaw, watch } from "vue";
import { MAX_TIME } from "./SearchDevice";
import { SERVER_ERROR } from "./ServerConnect";
import { Get_Setting, Modify_Setting } from "./Setting";
import { get_lastupdate_time } from "./GlobalUtility";

// 랜덤 색상 생성 함수
export const generateRandomColor = () => {
  const randomColor = Math.floor(Math.random() * 16777215).toString(16);  // 0 ~ 16777215 범위에서 랜덤 색상 값 생성
  return `#${randomColor.padStart(6, '0')}`;  // 6자리 hex 코드로 반환
};

// 장치별로 색상 할당 함수
export const getColorByDeviceId = (deviceId) => {
  if (deviceId === SERVER_ERROR) return 'black';
  const colors = ['red', 'blue', 'green', 'orange', 'purple', 'brown', 'pink', 'yellow'];
  const index = Math.abs(hashCode(deviceId)) % colors.length;
  return colors[index];
};
// 해시 함수로 deviceId의 고유 색상 인덱스 생성
const hashCode = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

// 장치별로 색상 할당 함수
export const getColorByStatus = (timestamp) => {
  let timeValue = get_lastupdate_time(timestamp);
  // 🛠️ timeValue가 숫자가 아니면 기본값 Infinity 사용
  if (isNaN(timeValue) || timeValue === undefined) {
    timeValue = MAX_TIME.value;
  }

  // 설정된 colorSettings에서 적절한 색상 찾기
  // 🛠️ find()가 정상적으로 값을 찾지 못할 경우 기본값 반환
  const setting = colorSettings.value.find(s => timeValue < s.time) || colorSettings.value[colorSettings.value.length - 1];
  return setting ? hexToRgba(setting.color, setting.alpha) : 'rgba(0,0,0,0.5)';
};

// 기본 설정 (시간 기준 색상)
const colorSettings = ref([]);
// 새로운 행 추가 (최대 시간값보다 작은 값만 가능)
export const addStateColorSetting = () => {
  const lastValidIndex = colorSettings.value.length - 1; // 마지막 행(Infinity) 제외

  // 마지막 행 바로 위의 값 가져오기
  const prevTime = lastValidIndex > 0 ? colorSettings.value[lastValidIndex - 1].time : 0;
  const nextTime = colorSettings.value[lastValidIndex].time; // 마지막 행 (Infinity) 값

  // 중간 값 계산 (첫 번째 추가 시 기본값 60 사용)
  const newTime = prevTime > 0 ? Math.floor((prevTime + nextTime) / 2) : 60;

  colorSettings.value.splice(lastValidIndex, 0, { time: newTime, color: '#000000', alpha: 0.5 });
};
// 행 삭제 (마지막 행 제외)
export const removeStateColorSetting = (index) => {
  if (index < 0 || index >= colorSettings.value.length - 1) return;
  colorSettings.value.splice(index, 1);
};
// RGB → HEX 변환
export const rgbaToHex = (rgba) => {
  const [r, g, b] = rgba.match(/\d+/g).map(Number);
  return `#${((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
};
// HEX → RGBA 변환
export const hexToRgba = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
};
// 로컬저장소에서 설정값 불러오기
export const loadColorSettings = computed(() => colorSettings.value);

// 설정 localStorage에 저장
watch(colorSettings , (newSettings) => {
  localStorage.setItem('colorSettings', JSON.stringify(newSettings));
}, { deep: true });
export const resetStateColorSettings = () => {
  colorSettings.value = Get_Setting('updatetime_status_range');
}
export const validateTime = (index) => {
  const prevTime = colorSettings.value[index - 1]?.time ?? 0;
  const nextTime = colorSettings.value[index + 1]?.time ?? MAX_TIME;

  if (colorSettings.value[index].time <= prevTime) {
    colorSettings.value[index].time = prevTime + 1;
  }

  if (colorSettings.value[index].time >= nextTime) {
    colorSettings.value[index].time = nextTime - 1;
  }
};
export const saveStateColorSetting = async () => {
  await Modify_Setting('updatetime_status_range', [...toRaw(colorSettings.value)]);
};